import { StyleRules, makeStyles, Theme } from '@material-ui/core/styles';
import { SelectClassKey } from '@material-ui/core/Select';

import { core as theme } from '../styles/core';

export const useMenuStyles = makeStyles<Theme>(theme => ({
  root: {
    boxShadow: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

export const MuiSelect: Partial<StyleRules<SelectClassKey>> = {
  root: {
    ...theme.typography.body2,
    color: theme.palette.grey[700],
  },
  select: {
    '&$disabled': {
      cursor: 'not-allowed',
    },
    '.Mui-focused &': {
      backgroundColor: theme.palette.common.white,
      borderRadius: 4,
    },
  },
  outlined: {
    padding: `9px 32px 9px 8px`,
  },
  icon: {
    color: theme.palette.grey[500],
    top: 'calc(50% - 10px)',
    '.Mui-focused &': {
      color: theme.palette.primary.main,
    },
  },
};
